import React from 'react';
import { AppBar, Toolbar, Button, Box, IconButton, Avatar, Badge, Container, Menu, MenuItem } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../assets/logo.webp';

export default function Navigation() {
  const { isAuthenticated, user, login, logout, isAdmin } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.items);
  const cartItemCount = cartItems.reduce((total, item) => total + item.quantity, 0);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleClose();
  };

  return (
    <AppBar position="static" sx={{ bgcolor: 'white', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: '80px !important' }}>
          <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <img src={logo} alt="Kosmo Studio" style={{ height: '100px', marginRight: '16px' }} />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ color: 'primary.main' }}>
              <LanguageSwitcher />
            </Box>
            
            <Button
              color="primary"
              component={RouterLink}
              to="/"
              sx={{ fontFamily: '"Montserrat", sans-serif', fontWeight: 600 }}
            >
              {t('nav.home')}
            </Button>

            <Button
              color="primary"
              component={RouterLink}
              to="/products"
              sx={{ fontFamily: '"Montserrat", sans-serif', fontWeight: 600 }}
            >
              {t('nav.products')}
            </Button>

            <Button
              color="primary"
              component={RouterLink}
              to="/energies"
              sx={{ fontFamily: '"Montserrat", sans-serif', fontWeight: 600 }}
            >
              {t('nav.energies')}
            </Button>

            <IconButton
              component={RouterLink}
              to="/cart"
              size="large"
              color="primary"
              sx={{ ml: 1 }}
            >
              <Badge badgeContent={cartItemCount} color="primary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>

            {isAuthenticated ? (
              <>
                <IconButton
                  size="large"
                  color="primary"
                  onClick={handleMenu}
                >
                  {user?.picture ? (
                    <Avatar src={user.picture} sx={{ width: 32, height: 32 }} />
                  ) : (
                    <AccountCircleIcon />
                  )}
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem onClick={() => handleNavigate('/membership')}>
                    Mi Membresía
                  </MenuItem>
                  {isAdmin && (
                    <MenuItem onClick={() => handleNavigate('/admin')}>
                      Admin Panel
                    </MenuItem>
                  )}
                  <MenuItem onClick={logout}>
                    Cerrar Sesión
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                color="primary"
                onClick={login}
                sx={{ fontFamily: '"Montserrat", sans-serif', fontWeight: 600 }}
              >
                {t('nav.login')}
              </Button>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
